import * as BackendAPI from '../../services/API';

function getDestinationsRequestStart() {
    return { type: 'GET_DESTINATIONS_REQUEST_START' };
}

function getDestinationsRequestSuccess(response) {
    return { type: 'GET_DESTINATIONS_REQUEST_SUCCESS', payload: response };
}

function getDestinationsRequestFailure() {
    return { type: 'GET_DESTINATIONS_REQUEST_FAILURE' };
}

function destinationSelection(payload) {
    return { type: 'DESTINATION_SELECTION', payload };
}

const getDestinations = params => (dispatch) => {
    dispatch(getDestinationsRequestStart());
    return BackendAPI.getDestinations(params)
        .then(async (res) => {
            const { countries } = res;
            const regions = { ...params, regions: { countries } };
            const hotels = await BackendAPI.getRegionsHotels(regions);
            dispatch(getDestinationsRequestSuccess(hotels));
        })
        .catch((error) => {
            dispatch(getDestinationsRequestFailure(error));
        });
};

const getDestinationType = destination => (dispatch, getState) => {
    const { destinations: { data: { countries } } } = getState();
    const isCountry = countries.find(country => country.value === destination.value);
    return isCountry ? 'country' : 'hotel';
};

export { getDestinations, destinationSelection, getDestinationType };
